<template>
  <div class="badge rounded-pill">{{ name }}</div>
</template>

<script>
export default {
  name: "Etiquette",
  props: {
    postType: String,
    etiquetteType: String,
  },
  computed: {
    name: function () {
      if (this.etiquetteType) {
        return this.$store.state.i18n[this.etiquetteType];
      }

      return this.$store.getters.getPostTypeName(this.postType);
    },
  },
};
</script>
